import i18n from '../../i18n.js';

function getValue(user, key) {
  return user[key];
}

const validationFunctions = {
  name: user => {
    const value = getValue(user, 'name');
    
    if (value.length === 0) {
      return i18n.global.t('settings.errors.noName');
    } else if (value.length < 2) {
      return i18n.global.t('settings.errors.tooShortName');
    } else if (value.length > 30) {
      return i18n.global.t('settings.errors.tooLongName');
    }

    return '';
  },
  phone_number: user => {
    const value = getValue(user, 'phone_number')
    
    if (value.length > 0 && value.length < 3) {
      return i18n.global.t('settings.errors.tooShortPhoneNumber');
    } else if (value.length > 30) {
      return i18n.global.t('settings.errors.tooLongPhoneNumber');
    }

    return '';
  },
  password: user => {
    const value = getValue(user, 'password');

    if (value.length === 0) {
      return i18n.global.t('settings.errors.noPassword');
    } else if (value.length < 2) {
      return i18n.global.t('settings.errors.tooShortPassword');
    }

    return '';
  },
  password_new: user => {
    const value = getValue(user, 'password_new');
    const valueRepeat = getValue(user, 'password_new_repeat');

    if (value.length === 0) {
      return i18n.global.t('settings.errors.noPassword');
    } else if (value.length < 6) {
      return i18n.global.t('settings.errors.tooShortPassword');
    } else if (value !== valueRepeat) {
      return i18n.global.t('settings.errors.repeatPassword');
    }

    return '';
  },
  password_new_repeat: user => {
    const value = getValue(user, 'password_new');
    const valueRepeat = getValue(user, 'password_new_repeat');

    if (value.length === 0) {
      return i18n.global.t('settings.errors.noPassword');
    } else if (value.length < 6) {
      return i18n.global.t('settings.errors.tooShortPassword');
    } else if (value !== valueRepeat) {
      return i18n.global.t('settings.errors.repeatPassword');
    }

    return '';
  }
};

function validateSingleField(user, key) {
  return validationFunctions[key](user);
}

function validateAllFields(user) {
  const errors = {};

  Object.keys(validationFunctions).forEach(key => {
    const message = validationFunctions[key](user);

    if (message.length > 0) {
      errors[key] = message;
    }
  });

  return errors;
}

export { validateSingleField, validateAllFields };
